import { AppModule } from '@/shared/types';
import * as routes from './routes';

export { useInviteStore } from './stores/invite';

export const InviteModule: AppModule = {
  routes,
};
